function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es6.array.is-array.js";
import "core-js/modules/es6.regexp.search.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.object.create.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.object.set-prototype-of.js";
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import { templateMixin } from './templateMixin';
import cloneDeep from 'lodash/cloneDeep';
var DEFAULT_ITEMS_PER_PAGE = 10;
var ITEMS_PER_PAGE_RANGE = [10, 20, 50, 100];
var FETCH_LIST_DEBOUNCE_TIME_MS = 300;
var DEFAULT_TABLE_PAGINATION_OPTIONS = {
  page: 1,
  itemsPerPage: DEFAULT_ITEMS_PER_PAGE,
  sortBy: [],
  sortDesc: [],
  groupBy: [],
  groupDesc: [],
  multiSort: false,
  mustSort: false
};
export default {
  name: 'CoreListViewPage',
  mixins: [templateMixin],
  props: {
    /**
     * Function to fetch items
     * @type {Function}
     * @required
     * @param {Object} params (search: string, page: number, perPage: number, ...externalFetchParams)
     * @returns {Promise} (items: Array, total: number)
     */
    fetchItems: {
      type: Function,
      required: false,
      "default": null
    },
    staticItems: {
      type: Array,
      "default": function _default() {
        return [];
      },
      required: false
    },
    externalFetchParams: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    /**
     * Function to delete item
     * @type {Function}
     * @required
     * @param {Object} item (item from fetchItems request)
     */
    deleteItem: {
      type: Function,
      required: false,
      "default": null
    },
    /**
     * Snack message to show after successful delete
     * @type {String}
     */
    deleteItemSnackMessage: {
      type: String,
      required: false,
      "default": ''
    },
    /**
     * Snack message to show after error on delete
     * @type {String}
     */
    deleteItemErrorSnackMessage: {
      type: [String, Function],
      required: false,
      "default": ''
    },
    /**
     * Table headers
     * @type {Array} [{ text: String (col label), value: String (item property key), align?: String, sortable?: Boolean }]
     */
    tableHeaders: {
      type: Array,
      required: true
    },
    /**
     * identifier key for items, needs to be unique and needs to exist in all items
     * @type {String}
     * @default 'id'
     */
    tableItemKey: {
      type: String,
      "default": 'id'
    },
    /**
     * should the core-header be shown, or is this a headless list?
     * if unset, the header-buttons obviously will also not be shown, and all the attributes be ignored.
     * @type {Boolean}
     * @default true
     */
    showHeader: {
      type: Boolean,
      "default": true
    },
    /**
     * Header buttons
     * @type {Array} [{ dataCy?: string, color?: string, type?: string, tooltip?: string, href?: string, target?: string, icon?: string, action?: string }]
     */
    headerButtons: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    /**
     * Page headline
     * @type {String}
     */
    headline: {
      type: String,
      "default": ''
    },
    /**
     * Page subtitle
     * @type {String}
     */
    subtitle: {
      type: String,
      "default": ''
    },
    /**
     * Function to get the href for a row
     * @type {Function}
     * @param {Object} item
     * @returns {String}
     */
    rowHref: {
      type: Function,
      required: false,
      "default": function _default() {
        return function () {
          return '#';
        };
      }
    },
    createButtonHref: {
      type: String,
      "default": ''
    },
    hasSearchBar: {
      type: Boolean,
      "default": true
    },
    fetchErrorMessage: {
      type: String,
      required: false,
      "default": ''
    },
    showBetaBadge: {
      type: [Boolean, String],
      required: false,
      "default": function _default() {
        return false;
      }
    },
    emptyStateIcon: {
      type: String,
      required: true
    },
    emptyStateTitle: {
      type: String,
      required: true
    },
    emptyStateDescription: {
      type: String,
      required: true
    },
    emptyStateButtonLabel: {
      type: String,
      required: false,
      "default": ''
    },
    emptyStateButtonDisabled: {
      type: Boolean,
      required: false,
      "default": false
    },
    hideEditingButtons: {
      type: Boolean,
      required: false,
      "default": false
    }
  },
  data: function data() {
    return {
      textSearchValue: '',
      showDeletePrompt: false,
      isFetching: false,
      deleteItemError: null,
      itemToBeDeleted: null,
      items: [],
      totalItemsCount: null,
      tablePaginationOptions: _objectSpread({}, DEFAULT_TABLE_PAGINATION_OPTIONS)
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    hasCreateButton: function hasCreateButton() {
      return typeof this.$listeners['button:create'] === 'function' || this.createButtonHref;
    },
    deletePromptTitle: function deletePromptTitle() {
      return this.$i18n_t('Core.ListViewPage.deleteItem.prompt.title');
    },
    deletePromptCancelButtonLabel: function deletePromptCancelButtonLabel() {
      return this.$i18n_t('Core.ListViewPage.deleteItem.prompt.cancelButton.label');
    },
    deletePromptDeleteButtonLabel: function deletePromptDeleteButtonLabel() {
      return this.$i18n_t('Core.ListViewPage.deleteItem.prompt.deleteButton.label');
    },
    tableFooterProps: function tableFooterProps() {
      return {
        itemsPerPageText: this.$i18n_t('Core.ListViewPage.tableFooter.itemsPerPageText'),
        itemsPerPageOptions: [].concat(ITEMS_PER_PAGE_RANGE)
      };
    },
    completeTableHeaders: function completeTableHeaders() {
      var _this = this;
      var headers = cloneDeep(this.tableHeaders);

      // Determine if any buttons should be visible
      var hasEditButton = typeof this.$listeners['button:edit'] === 'function' && !this.hideEditingButtons;
      var hasDeleteButton = typeof this.deleteItem === 'function' && !this.hideEditingButtons;
      var actionHeaderButtons = [];
      if (hasEditButton) {
        actionHeaderButtons.push({
          icon: 'fal fa-edit',
          visible: hasEditButton,
          onClick: function onClick(item) {
            return _this.$emit('button:edit', item);
          }
        });
      }
      if (hasDeleteButton) {
        actionHeaderButtons.push({
          icon: 'fal fa-trash-alt',
          visible: hasDeleteButton,
          onClick: function onClick(item) {
            return _this.onClickDeleteItem(item);
          }
        });
      }
      if (actionHeaderButtons.length > 0) {
        var actionsHeader = {
          text: this.$i18n_t('Core.ListViewPage.table.headers.actions'),
          isButtons: true,
          width: '125px',
          align: 'center',
          sortable: false,
          buttons: actionHeaderButtons
        };
        headers.push(actionsHeader);
      }
      return headers;
    },
    combinedHeaderButtons: function combinedHeaderButtons() {
      var _this2 = this;
      var buttons = _toConsumableArray(this.headerButtons);
      if (this.hasCreateButton !== false && this.hideEditingButtons === false) {
        var createButton = {
          title: this.$i18n_t('Core.ListViewPage.createButton.label'),
          color: this.color,
          dataCy: 'create_button',
          icon: 'fal fa-plus',
          onClick: function onClick() {
            return _this2.$emit('button:create');
          },
          href: this.createButtonHref
        };
        if (typeof createButton.onClick !== 'function' && !createButton.href) {
          // navigate to current path + /new
          createButton.href = this.$router.resolve({
            path: "".concat(this.$route.path, "/new")
          }).href;
        }
        buttons.push(createButton);
      }
      return buttons;
    },
    actualItems: function actualItems() {
      if (typeof this.fetchItems === 'function') {
        return this.items;
      }
      return this.staticItems;
    },
    isEmptyList: function isEmptyList() {
      return this.totalItemsCount === 0;
    }
  }),
  watch: {
    tablePaginationOptions: {
      handler: function handler(newVal, oldVal) {
        // store new pagination values in the route
        this.updateRouterParams({
          page: newVal.page,
          perPage: newVal.itemsPerPage,
          sortBy: newVal.sortBy[0],
          sortDirection: newVal.sortDesc[0] ? 'desc' : 'asc'
        });

        // store new items-per-page value in the store
        if (newVal.itemsPerPage !== oldVal.itemsPerPage) {
          this.$store.commit('app/setRowsPerPage', newVal.itemsPerPage);
          localStorage.setItem('userSelectedItemsPerList', newVal.itemsPerPage);
        }

        // fetch new items
        this.callFetchItems();
      },
      deep: true
    },
    textSearchValue: {
      handler: function handler(newVal) {
        this.updateRouterParams({
          search: newVal
        });
        this.$emit('update:search', newVal);
        this.callFetchItems();
      }
    },
    externalFetchParams: {
      handler: function handler() {
        this.callFetchItems();
      },
      deep: true
    },
    totalItemsCount: {
      handler: function handler(newVal) {
        this.$emit('update:total-count', newVal);
      },
      immediate: true
    },
    staticItems: {
      handler: function handler(newVal) {
        if (typeof this.fetchItems === 'function') {
          return;
        }
        this.totalItemsCount = newVal.length;
      },
      immediate: true,
      deep: true
    }
  },
  created: function created() {
    if (!Array.isArray(this.tableHeaders) || this.tableHeaders.length === 0) {
      console.warn('tableHeaders is not defined or empty');
      return;
    }
    var page = parseInt(this.$route.query.page, 10) || DEFAULT_TABLE_PAGINATION_OPTIONS.page;
    var itemsPerPage = parseInt(this.$route.query.perPage, 10) ||
    // per query param
    parseInt(localStorage.getItem('userSelectedItemsPerList')) ||
    // per local storage
    parseInt(this.$store.state.app.rowsPerPage) ||
    // per vuex store
    DEFAULT_TABLE_PAGINATION_OPTIONS.itemsPerPage; // per default
    var sortBy = this.$route.query.sortBy || DEFAULT_TABLE_PAGINATION_OPTIONS.sortBy[0];
    var sortDesc = this.$route.query.sortDirection || (DEFAULT_TABLE_PAGINATION_OPTIONS.sortDesc[0] ? 'desc' : 'asc');
    this.tablePaginationOptions = _objectSpread(_objectSpread({}, this.tablePaginationOptions), {}, {
      page: page,
      itemsPerPage: itemsPerPage,
      sortBy: [sortBy],
      sortDesc: [sortDesc === 'desc']
    });
    var textSearchValueFromQuery = this.$route.query.search || '';
    if (textSearchValueFromQuery) {
      this.textSearchValue = textSearchValueFromQuery;
    }
    this.callFetchItems();
  },
  methods: {
    callDeleteItem: function callDeleteItem() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _this3.isDeleting = true;
              if (!(typeof _this3.deleteItem !== 'function')) {
                _context.next = 5;
                break;
              }
              console.warn('deleteItem function is not defined');
              return _context.abrupt("return");
            case 5:
              _context.next = 7;
              return _this3.deleteItem(_this3.itemToBeDeleted);
            case 7:
              _this3.itemToBeDeleted = null;
              if (_this3.deleteItemSnackMessage) {
                _this3.$snack(_this3.deleteItemSnackMessage, 'success');
              } else {
                _this3.$snack(_this3.$i18n_t('Core.ListViewPage.deleteItem.success.snackMessage'), 'success');
              }
              _this3.showDeletePrompt = false;
              _this3.callFetchItems();
              _context.next = 18;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              _this3.itemToBeDeleted = null;
              _this3.deleteItemError = _context.t0;
              if (_this3.deleteItemErrorSnackMessage) {
                if (typeof _this3.deleteItemErrorSnackMessage === 'function') {
                  _this3.$snack(_this3.deleteItemErrorSnackMessage(_context.t0), 'error');
                } else {
                  _this3.$snack(_this3.deleteItemErrorSnackMessage, 'error');
                }
              } else {
                _this3.$snack(_this3.$i18n_t('Core.ListViewPage.deleteItem.error.snackMessage'), 'error');
              }
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 13]]);
      }))();
    },
    onClickDeleteItem: function onClickDeleteItem(item) {
      this.showDeletePrompt = true;
      this.itemToBeDeleted = item;
    },
    updateRouterParams: function updateRouterParams(params) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _this4.$router.replace({
                query: _objectSpread(_objectSpread({}, _this4.$route.query), params)
              });
            case 3:
              _context2.next = 8;
              break;
            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 5]]);
      }))();
    },
    callFetchItems: debounce(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _yield$this$fetchItem, items, total;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(typeof this.fetchItems !== 'function')) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            _context3.prev = 2;
            this.isFetching = true;
            _context3.next = 6;
            return this.fetchItems(_objectSpread({
              search: this.textSearchValue,
              page: this.tablePaginationOptions.page,
              perPage: this.tablePaginationOptions.itemsPerPage,
              sortBy: this.tablePaginationOptions.sortBy[0],
              sortDirection: this.tablePaginationOptions.sortDesc[0] ? 'desc' : 'asc'
            }, this.externalFetchParams));
          case 6:
            _yield$this$fetchItem = _context3.sent;
            items = _yield$this$fetchItem.items;
            total = _yield$this$fetchItem.total;
            this.items = items;
            this.totalItemsCount = total;
            _context3.next = 17;
            break;
          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](2);
            console.error(_context3.t0);
            this.$snack(this.$i18n_t(this.fetchErrorMessage), 'error');
          case 17:
            _context3.prev = 17;
            this.isFetching = false;
            return _context3.finish(17);
          case 20:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this, [[2, 13, 17, 20]]);
    })), FETCH_LIST_DEBOUNCE_TIME_MS),
    getValueByPath: function getValueByPath(obj, path) {
      return get(obj, path);
    },
    getItemHref: function getItemHref(item) {
      return typeof this.rowHref === 'function' ? this.rowHref(item) : '#';
    },
    navigateToRunner: function navigateToRunner(deviceSyncStatus, linkedVirtualDevices) {
      if (linkedVirtualDevices === 0) {
        return;
      }
      if (deviceSyncStatus.isRunning || !deviceSyncStatus.isRunning && deviceSyncStatus.syncFailed === true) {
        this.$router.push("/background-jobs/?tab=bg-jobs-edit&openRunnerId=".concat(deviceSyncStatus.backgroundRunnerId));
      }
    }
  }
};